import React from 'react';

import { Treatment } from '../../../../types/treatment';
import FormsDisplayLayout from '../../FormsDisplayLayout/FormsDisplayLayout';
import { title, DISABLED_FIELDS } from '../PaidBillForm';

const PaidBillDisplay = ({ treatment }: { treatment: Treatment }) => {
  return <FormsDisplayLayout treatment={treatment} disabledFields={DISABLED_FIELDS} />;
};

export default PaidBillDisplay;

export const PaidBillDisplayOption = {
  title: title,
  Component: PaidBillDisplay,
};
